export const DEFAULT_LANGUAGE = "fr"
export const PREFIX = "af"
